import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from 'environments/environment';

/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const authInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    const authService = inject(AuthService);


    let opts: any = {}
    if (req.url.startsWith('~')) { //points to our new backend endpoint
        // opts.url = new URL(req.url.substring(1), 'http://devx.aura.ir:3000/v1/').href
        // opts.url = new URL(req.url.substring(1), 'https://new.aura.ir/v1/').href

        let path = `v1/${req.url.substring(1)}`
        opts.url = new URL(path, environment.apiUrl).href
    } else if (req.url.startsWith('orb~')) {
        let path = `v1/${req.url.substring(4)}`
        opts.url = new URL(path, environment.orbApiUrl).href
    }

    // Clone the request object
    let newReq = req.clone(opts)

    // Request
    //
    // If the access token didn't expire, add the Authorization header.
    // We won't add the Authorization header if the access token expired.
    // This will force the server to return a "401 Unauthorized" response
    // for the protected API routes which our response interceptor will
    // catch and delete the access token from the local storage while logging
    // the user out from the app.
    if (authService.accessToken && !AuthUtils.isTokenExpired(authService.accessToken)) {
        newReq = newReq.clone({
            headers: newReq.headers.set('Authorization', 'Bearer ' + authService.accessToken)
        });
    }

    // Response
    return next(newReq).pipe(
        catchError((error) => {

            // console.log("errrorrrzz", error)
            // Catch "401 Unauthorized" responses
            if (error instanceof HttpErrorResponse && error.url?.length > 0 && error.status === 401) {
                // Sign out
                authService.signOut();

                // Reload the app
                location.reload();
            }

            return throwError(error);
        })
    );
};
